export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'From chaos to clarity',
      subtitle: 'in your sales process.',
      description: 'Sales you can finally rely on.',
      cta: 'Stop the chaos in sales',
      ctaSecondary: 'How It Works'
    },
    about: {
      title: 'About Us',
      description: 'We are a marketing agency specializing in professional telemarketing solutions. For over 10 years, we\'ve been helping companies reach the right audience, increase their sales, and achieve measurable results.\nOur experienced sales specialists ensure that every call becomes an opportunity - for your business, your revenue, and your growth.\nReliable. Effective. Results-driven.',
      feature1Title: 'A Professional\nSales Team',
      feature1Desc: 'Highly skilled sales specialists who know how to turn every conversation into real results.',
      feature2Title: 'Results That\nInspire Trust',
      feature2Desc: 'Leading companies in Latvia rely on us and choose to work with our team.',
      feature3Title: 'Personalized\nApproach',
      feature3Desc: 'Every client receives a tailored, carefully crafted strategy designed specifically for their needs.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Professional telemarketing solutions designed to grow your business.',
      service1Title: 'B2B Sales',
      service1Desc: 'We conduct targeted outbound calls to identify valuable business partners, qualify their interest, and move conversations efficiently toward a closed deal.',
      service2Title: 'B2C Sales',
      service2Desc: 'We engage private customers with a personalized approach and dynamic communication strategies to increase sales and build long-term relationships with your brand.',
      service3Title: 'Market Research',
      service3Desc: 'Gain accurate and valuable insights into your market and customer needs through professional telephone surveys.',
      service4Title: 'Lead Generation',
      service4Desc: 'Targeted campaigns that help you identify and qualify high-value leads, creating a solid foundation for successful deals.'
    },
    contact: {
      title: 'Get a Consultation - Contact Us',
      description: '',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      message: 'Message',
      send: 'Stop the chaos in sales',
      success: 'Thank you! Your path to organized sales has begun!',
      successToast: 'Message sent. Our team will reach out shortly.',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+371 XXXX XXXX',
      messagePlaceholder: 'Tell us about your project',
      validation: {
        required: 'Please fill in this field',
        invalidEmail: 'Please enter a valid email address'
      }
    },
    footer: {
      copyright: '© 2016-2025 AP International Media Solutions. All rights reserved. V.1.2.',
      services: 'Services',
      contact: 'Contact',
      companyDetails: 'Company Details',
      tagline: 'Professional telemarketing services'
    }
  },
  lv: {
    nav: {
      home: 'Sākums',
      about: 'Par mums',
      services: 'Pakalpojumi',
      contact: 'Kontakti'
    },
    hero: {
      title: 'No haosa uz skaidru,',
      subtitle: 'prognozējamu pārdošanu.',
      description: 'Pārdošana, kurai var uzticēties.',
      cta: 'Atteikties no pārdošanas haosa',
      ctaSecondary: 'Uzziniet, kā tas strādā'
    },
    about: {
      title: 'Par mums',
      description: 'Mēs esam mārketinga aģentūra, kas specializējas profesionālos telemarketinga risinājumos. Jau vairāk nekā 10 gadus palīdzam uzņēmumiem sasniegt īsto auditoriju, palielināt pārdošanas apjomus un iegūt izmērāmus rezultātus.\nMūsu pieredzējušie pārdošanas speciālisti strādā tā, lai katrs zvans kļūtu par iespēju - jūsu uzņēmumam, jūsu pārdošanai un jūsu izaugsmei.\nUzticami. Efektīvi. Rezultatīvi.',
      feature1Title: 'Profesionāla\npārdošanas komanda',
      feature1Desc: 'Augsti kvalificēti pārdošanas speciālisti, kas zina, kā pārvērst sarunu rezultātos.',
      feature2Title: 'Rezultāti,\nkas rada uzticību',
      feature2Desc: 'Mums uzticas un ar mums sadarbojas vadošie Latvijas uzņēmumi.',
      feature3Title: 'Individuāla\npieeja',
      feature3Desc: 'Katrs sadarbības partneris saņem individuālu, rūpīgi izstrādātu pieeju.'
    },
    services: {
      title: 'Mūsu pakalpojumi',
      subtitle: 'Profesionāli telemarketinga risinājumi jūsu biznesa izaugsmei.',
      service1Title: 'B2B pārdošana',
      service1Desc: 'Mēs veicam mērķtiecīgus izejošos zvanus, lai atrastu jūsu uzņēmumam vērtīgus partnerus, kvalificētu viņu intereses un palīdzētu sarunām ātri virzīties līdz darījumam.',
      service2Title: 'B2C pārdošana',
      service2Desc: 'Mēs uzrunājam privātos klientus ar personalizētu pieeju un dinamiskām komunikācijas stratēģijām, lai palielinātu pārdošanas apjomu un veidotu ilgtermiņa attiecības ar jūsu zīmolu.',
      service3Title: 'Tirgus izpēte',
      service3Desc: 'Iegūstiet precīzas un vērtīgas atziņas par savu tirgu un klientu vajadzībām, izmantojot profesionālas telefona aptaujas.',
      service4Title: 'Līdu ģenerēšana',
      service4Desc: 'Mērķtiecīgas kampaņas, kas palīdz atrast un kvalificēt vērtīgus līdus, nodrošinot stabilu pamatu veiksmīgiem darījumiem.'
    },
    contact: {
      title: 'Saņemiet konsultāciju - sazinieties ar mums',
      description: '',
      name: 'Vārds',
      email: 'E-pasts',
      phone: 'Tālrunis',
      whatsapp: 'WhatsApp',
      message: 'Ziņa',
      send: 'Atteikties no pārdošanas haosa',
      success: 'Paldies! Jūsu ceļš uz sakārtotu pārdošanu ir sācies!',
      successToast: 'Ziņa nosūtīta. Mēs jau strādājam pie jūsu pieprasījuma.',
      namePlaceholder: 'Jūsu vārds',
      emailPlaceholder: 'jusu@epasts.lv',
      phonePlaceholder: '+371 XXXX XXXX',
      messagePlaceholder: 'Pastāstiet mums par savu projektu',
      validation: {
        required: 'Lūdzu, aizpildiet šo lauku',
        invalidEmail: 'Lūdzu, ievadiet derīgu e-pasta adresi'
      }
    },
    footer: {
      copyright: '© 2016-2025 AP International Media Solutions. Visas tiesības aizsargātas. V.1.2.',
      services: 'Pakalpojumi',
      contact: 'Kontakti',
      companyDetails: 'Uzņēmuma rekvizīti',
      tagline: 'Profesionāli telemarketinga pakalpojumi'
    }
  }
};